<template>
  <div>
    <!-- 模型裁剪 -->
    <MapModal
      :modalNode="modalNode"
      :title="bimModelClipping.title"
      :id="bimModelClipping.id"
      :close="close"
    >
      <template slot="head">
        <div class="head-operate">
          <el-button type="primary" @click="addModelCutFace">
            <i class="el-icon-zengjia"></i> 新增方案
          </el-button>
        </div>
      </template>
    </MapModal>
    <!--  -->
    <modelCutAdd
      v-show="cutType"
      :editData="editData"
      :cutType="cutType"
      :selectedScene="selectedScene"
      @close="closeAdd"
      @getList="getBimModeSlicedList"
      ref="modelCutAdd"
    ></modelCutAdd>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const modelCutAdd = () => import("@/components/tables/newModelCut/Add");
import * as mapWork from "./map.js";
import { getBimModeSlicedList, postBimModeSlicedDelete } from "@/api/api";
export default {
  name: "new-model-cut",
  components: { MapModal, modelCutAdd },
  props: ["selectedScene", "close"],
  data() {
    return {
      bimModelClipping: {
        title: "模型剖切",
        id: "bimModelClipping", // id和ref使用的同一个
      },
      modalNode: {
        bimModelClipping: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -425,
            // unit: "px", // 默认px
          },
          width: "380px", // 宽度配置 默认450px
          height: `${window.screen.height - 200 - 80}px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "bimVideoCategoryTree", // id和ref使用的同一个
            // name: "text", // 树的展示字段 默认name

            i_icon: {
              level_1: "el-icon-scissors",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            search: {
              //不需要搜索直接不传
              // type: "", //暂时无用 预留字段 后期配置 判断是否是ajax
              keywords: "text", // 搜素配置关键字 默认是name
              // filterNode: this.filterNode, // 搜索的逻辑 可以自己配置
            },
            // nodeClick 事件绑定
            nodeClick: this.nodeClick,
          },
          //模态框foot配置
          // foot: {
          //   addCategory: {
          //     type: "button",
          //     buttonType: "primary",
          //     i_icon: "el-icon-zengjia",
          //     title: "表单",
          //     disabled: false,
          //     click: this.addCategory,
          //   },
          // },
        },
      },
      cutType: false,
      renewState: "add",
      editData: null,
    };
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    // 初始化
    addModelCutFace() {
      if (this.selectedScene) {
        this.cutType = "add";
        mapWork.editGraphicCutType("add");
      } else {
        this.$message({
          message: "请先选择一个场景",
          type: "warning",
          duration: 2000,
        });
      }
    },
    getBimModeSlicedList(businessId = this.selectedScene.id, dataType = 2) {
      const params = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        businessId: businessId,
        dataType: dataType,
      };
      getBimModeSlicedList(params).then((res) => {
        let { data } = res.data;
        data.forEach((i) => {
          i.operate = [
            {
              i_icon: "small-operation-btn el-icon-edit",
              click: this.edit,
            },
            {
              i_icon: "small-operation-btn el-icon-delete",
              click: this.delete,
            },
          ];
        });
        this.modalNode.bimModelClipping.content.treeDataJson = data;
      });
    },
    init() {
      this.getBimModeSlicedList(this.selectedScene.id, 2);
      this.cutType = false;
    },
    deleteEmptyChildren(data) {
      if (data && data.length > 0) {
        data.forEach((item, index) => {
          if (item.children?.length == 0 && item.id != "-1") {
            delete item.children;
          } else {
            this.deleteEmptyChildren(item.children);
          }
        });
      }
      return data;
    },
    edit(e) {
      // console.log(e, modelCutAdd);
      this.editData = {
        id: e.id,
        projectId: e.projectId,
        businessId: e.businessId,
        name: e.name,
        cutModel: e.cutModel,
        cutType: e.cutType,
        cutPosition: e.cutPosition,
        distance: e.distance,
        normalz: e.normalz,
        dataType: e.dataType,
      };
      this.cutType = "edit";
      console.log(this.editData);
    },
    delete(e) {
      postBimModeSlicedDelete({
        id: e.id,
      })
        .then((res) => {
          this.getBimModeSlicedList(this.selectedScene.id, 2);
          this.$notify({
            title: "删除成功",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "删除成功",
            message: "",
            type: "error",
            duration: 960,
            offset: 320,
          });
        });
    },
    nodeClick(e) {
      // if (mapWork.graphicCutType == "") {
      let { cutModel, cutPosition } = e;
      mapWork.editGraphicCutType("show");
      mapWork.assemblyData(cutPosition, cutModel, e.id, e.normalz);
      // }
    },
    closeAdd() {
      this.cutType = false;
    },
  },
  mounted() {
    // this.init();
  },
  watch: {
    selectedScene(newVal, oldVal) {
      if (newVal) {
        this.submitData = this.editData;
        this.init();
      }
    },
    $attrs: {
      handler(val) {
        if (
          val.hasOwnProperty("style") &&
          val.style.hasOwnProperty("display")
        ) {
          console.log("v-show changed to:", val.style.display);
        }
      },
      deep: true,
    },
  },
  destroyed() {
    mapWork.init();
  },
};
</script>
<style lang="scss" scoped>
.isShowIcon {
  /deep/ .el-icon-plus {
    display: none !important;
  }
  /deep/ .el-icon-edit {
    display: none !important;
  }
  /deep/ .el-icon-delete {
    display: none !important;
  }
}
</style>
